import { NotifyForm } from "./NotifyForm";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="ah-hairline" />
            <span className="text-xs uppercase tracking-[0.28em] font-semibold text-[#1A362D]">
              About Activehuman
            </span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[#1A362D] leading-[1.08] tracking-tight font-medium">
            Built for people who want the <em className="italic text-[#C29B62] font-normal">basics</em> done right.
          </h2>
        </div>

        <div className="lg:col-span-7 space-y-6 text-[#4A5D56] font-light text-base md:text-lg leading-relaxed">
          <p>
            Activehuman is a modern Indian nutraceutical brand built around a simple idea — that better health usually
            comes from getting the fundamentals right, consistently, over time.
          </p>
          <p>
            We start with the everyday essentials many of us miss out on, beginning with Vitamin D3. Our formulations
            are designed to fit easily into your routine, without unnecessary complexity.
          </p>
          <p>
            We're preparing for launch. Join the early list to be the first to know — and to hear how we're building
            Activehuman, transparently.
          </p>

          <div id="notify" className="pt-6 border-t border-[#E5E8E3] mt-10">
            <NotifyForm testIdPrefix="about" />
          </div>
        </div>
      </div>
    </section>
  );
};
